/** @format */
import {ChangeEvent, ForwardedRef, forwardRef} from 'react';

import {TextFieldProps} from '@mui/material/TextField';

import {Box} from '@mui/material';

import {AsYouType} from 'libphonenumber-js';

import ErrorMessage from 'components/ErrorMessage';

import {removeNonDigits} from 'helpers/stringHelpers';

import {StyledTextField} from './styles';

type Props = {
  minLength?: number;
  maxLength?: number;
  errorText?: string;
  isNumber?: boolean;
  compact?: boolean;
} & TextFieldProps;

/**
 * Новый, более современный и универсальный инпут.
 * Компоненты из папки inputs в новых формах больше не используем!
 * Ключевые особенности нового инпута:
 * 1. Совместим с react-hook-form
 * 2. minLength, maxLength легко прокидываются одним параметром
 * 3. Можно прокидывать текст ошибки через errorText и выводить её в верстку
 * 4. Можно использовать как поле для ввода телефона с помощью type === tel
 * 5. При isNumber === true юзер печатает только цифры 0-9 (тип value остается string)
 * Компонент открыт для новых предложений по улучшению!
 */

const TextFieldWrap = forwardRef(
  (
    {minLength, maxLength, errorText, isNumber, compact, ...props}: Props,
    ref: ForwardedRef<HTMLInputElement>,
  ) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      if (!props.onChange) {
        return;
      }

      const inputEl = e.currentTarget;

      if (props.type === 'tel') {
        inputEl.value = new AsYouType().input(inputEl.value);
      }

      if (isNumber) {
        inputEl.value = removeNonDigits(inputEl.value);
      }

      props.onChange(e);
    };

    return (
      <Box>
        <StyledTextField
          {...props}
          compact={compact}
          inputRef={ref}
          slotProps={{
            ...(props.slotProps || {}),
            htmlInput: {
              minLength,
              maxLength,
              ...(props.slotProps?.htmlInput || {}),
            },
          }}
          error={Boolean(props.error || errorText)}
          onChange={handleChange}
        />
        {errorText && <ErrorMessage text={errorText} />}
      </Box>
    );
  },
);

TextFieldWrap.displayName = 'TextFieldWrap';

export {TextFieldWrap};
